import { buildIcs, downloadIcs, type IcsEvent } from '~/utils/ics';

/** Collects calendar events and downloads them as a single .ics file. */
export function useIcs() {
  let events: IcsEvent[] = [];

  return {
    removeAllEvents(): void {
      events = [];
    },
    addEvent(
      language: string,
      subject: string,
      description: string,
      location: string,
      begin: string | number | Date,
      stop: string | number | Date,
      url: string | null = null
    ): void {
      events.push({
        language,
        subject,
        description,
        location,
        begin,
        stop,
        url
      });
    },
    download(filename: string): void {
      downloadIcs(filename, buildIcs(events));
    }
  };
}
